import { Middleware } from '@nuxt/types'
import { ACTIVE_SUB_TAB_VIEW, CLOSED_SUB_TAB_VIEW } from '~/plugins/mixpanel/events'

const routeEvent = {
  '/scholarships/submitted/active': [ACTIVE_SUB_TAB_VIEW],
  '/scholarships/submitted/closed': [CLOSED_SUB_TAB_VIEW]
}

const guard: Middleware = ({ $mixpanel, route, $accessor }) => {
  if (!routeEvent[route.fullPath]) { return }

  setTimeout(() => {
    for (const event of routeEvent[route.fullPath]) {
      $mixpanel.track(event, { 'Maintenance mode': !!$accessor.account.isMaintenanceMode })
    }
  }, 500)
}

export default guard
